const unorm = require('unorm')

import { SubscriptionApi } from '../api/SubscriptionApi'
import { Subscription } from '../core/Subscription'
import { DeliveryApi } from '../api/DeliveryApi'

import { milkmanCities } from '../data/milkmanCities'
import { milkmanCitiesNoTimeRange } from '../data/milkmanCities'

import moment from 'moment'

export const subscriptionStore = {
	state: {
    	subscriptionParams: {
			name: null,
			street: null,
			zip_code: null,
			city: null,
			message: null,
			telephone: null,
			province: null,
			country: 'IT',
			code: null,
			point_name: null,
			latitude: null,
			longitude: null
		},

		calendar: [],
		delivery_day: null,

		shipment_zone_id: null,
		shipment_day: null,

		subscription: null,

		session_id: null,

		// 'milkman' or 'standart'
		shipment_type: 'sda',

		// 'fermo-point' or 'standard'
		delivery_type: 'standard',
	},

	config: {
		// activate milkman
		milkman: true,
		milkmanCities: [...milkmanCities, ...milkmanCitiesNoTimeRange]
	},

	updateSubscriptionParam (vars) {
		if (!vars) return
		var combining = /[\u0300-\u036F]/g
		var inputValue = vars.value
		var outputValue = ['city','latitude','longitude'].indexOf(vars.param) !== -1 ? inputValue : unorm.nfkd(inputValue).replace(combining, '')

		this.state.subscriptionParams[vars.param] = outputValue

		// activate MILKMAN only for some cities
	},

	updateShipmentZone (zone) {
		this.state.shipment_zone_id = zone
	},
	updateShipmentCourier (courier_name) {

		
		courier_name = courier_name.toLowerCase();

		this.state.shipment_type = courier_name.toLowerCase();
	},

	updateShipmentDay (day) {
		this.state.shipment_day = day
	},

	updateSubscription (vars) {
		var subscription = this.state.subscription
		var params = vars && vars.params ? vars.params : this.state.subscriptionParams


		var sm = new SubscriptionApi()

        return sm.update(subscription, params)

        .then(response => {
            this.state.subscription = new Subscription(response.body.data.resource)            
            return response
        })
	},

	updateCalendar (vars) {
		if (!vars || !vars.subscription || !vars.params) return Promise.reject(new Error('no calendar params'))
		var sm = new SubscriptionApi()
		return sm.calendar(vars.subscription, vars.params)

		.then(response => {
			this.state.calendar = response.body.data.resource.calendar
			this.state.delivery_day = moment(response.body.data.resource.calendar[0].date).day()
			return response
		})
	},

	getSubscription (vars) { 
	    if (!vars) return Promise.reject(new Error('no subscription token')) 
	    var sm = new SubscriptionApi() 
	 	return sm.get(vars.token) 
	 
	    .then(response => { 
	        this.state.subscription = new Subscription(response.body.data.resource)             
			return response 
		}) 
	}, 

	getCalendar (vars) {
		if (!vars || !vars.token) return Promise.reject(new Error('no subscription token'))
		var sm = new SubscriptionApi()

		return sm.getCalendar(vars.token)

		.then(response => {
			this.state.calendar = response.body.data.resource
			this.state.delivery_day = moment(response.body.data.resource[0].date).day()
			return response
		})
	}
}